import React, { useState } from "react";
import MenuItem from "./menu-item";
const NavMenu = (props) => {
    const [nav, setNav] = useState([]);
    const findParent = (nav, parentId) => {
        for (let item of nav) {
            if (item.id === parentId) {
                return item;
            }
            if (item.children.length) {
                const parent = findParent(item.children, parentId);
                if (parent) {
                    return parent;
                }
            }
        }
        return false;
    };
    const fillNav = () => {
        let nav = [];
        try {
            props.nav.edges[0].node.menuItems.nodes.forEach((item) => {
                item.children = [];
                if (!item.parentId) {
                    nav.push(item);
                    return;
                }
                const parent = findParent(nav, item.parentId);
                if (parent && parent.children) {
                    parent.children.push(item);
                }
            });
            setNav(nav);
        }
        catch (e) {
            console.warn("empty navigation: " + props.label); // eslint-disable-line
        }
    };
    //~ if (typeof window === "undefined") {
    //~ fillNav();
    //~ } else {
    //~ useEffect(fillNav, []);
    //~ }
    if (props?.nav?.edges[0]?.node?.menuItems?.nodes?.length) {
        if (!nav.length) {
            fillNav();
        }
    }
    else {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("nav", { id: props.id, role: "navigation", "aria-label": props.label, className: (props.className || "") + (props.visible ? " expanded" : " collapsed") },
        React.createElement("menu", { itemScope: "", itemType: "http://www.schema.org/SiteNavigationElement" }, nav.map((item) => (React.createElement(MenuItem, { containerClassName: props.containerClassName, containerClasses: item.containerClasses, linkClasses: item.linkClasses, key: item.id, path: item.path, label: item.label, id: item.id, databaseId: item.databaseId, children: item.children, dropdown: props.dropdown }))))));
};
export default NavMenu;
